export const LAUNCH_DARKLY_CLIENT_ID =
  process.env.ARCADIA_LAUNCH_DARKLY_CLIENT_ID ||
  'No LAUNCH_DARKLY_CLIENT_ID was set in the ENV';
